import React, { useEffect } from 'react';

const Header = () => {
  useEffect(() => {
    // 确保自定义元素就绪
    const ensure = () => {
      const v = (window.__TENRYU_HEADER_ASSET_VER ||= String(Date.now()));
      // 确保 tailwind 样式可用（供 header 的按钮类使用）
      if (!document.querySelector('link[data-tenryu-header-tailwind="1"]')){
        const l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = '/assets/tailwind.css?v=' + encodeURIComponent(v);
        l.setAttribute('data-tenryu-header-tailwind', '1');
        document.head.appendChild(l);
      }
      // 顶部导航配置（单一来源）
      if (!document.querySelector('script[data-tenryu-nav-config="1"]')){
        const s0 = document.createElement('script');
        s0.src = '/nav-config.js?v=' + encodeURIComponent(v);
        s0.defer = true;
        s0.setAttribute('data-tenryu-nav-config', '1');
        document.head.appendChild(s0);
      }
      if (!document.querySelector('script[data-tenryu-site-header="1"]')){
        const s = document.createElement('script');
        s.src = '/site-header.js?v=' + encodeURIComponent(v);
        s.defer = true;
        s.setAttribute('data-tenryu-site-header', '1');
        document.head.appendChild(s);
      }
    };
    ensure();
  }, []);
  return (
    <site-header />
  );
};

export default Header;